<template>
    <div :class="['qr-pop', { 'show-QrPop': isShowQrPop }]">
        <div class="qr-bg-box">
            <div class="clqr-btn" @click="clqrBtnClick">
                <img src="@/assets/clr_btn.png" />
            </div>
            <div class="qr-bg"></div>
            <div class="qr">
                <img src="@/assets/qr.png" />
            </div>
        </div>


    </div>
</template>
  
<script>

import store from '@/store';
import Vuex from 'vuex'


//映射 store参数
var mapGetters = Vuex.mapGetters;

export default {
    name: 'QrPop',
    data() {
        return {
            // isShowQrPop: false
        };
    },
    props: {

    },
    methods: {
        //关闭二维码
        clqrBtnClick() {
            this.$store.commit('hideQrPop');
        }
    },
    computed: {
        // 使用 mapGetters 辅助函数来映射 Vuex getter 到计算属性
        isShowQrPop: function () {
            return this.$store.getters.isShowQrPop;
        }
    }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">


@import '@/static/preboot.less';
@import '@/static/JAnimate.less';

.qr-pop {
    position: absolute;
    width: 100%;
    height: 100%;
    // min-height: (1535/@rem);
    background-color: rgba(0, 0, 0, 0.8);
    padding: 0;
    margin: 0;
    display: none;
}

.qr-bg-box {
    position: absolute;
    left: (120/@rem);
    // top: (390/@rem);
    top: 50%;
    width: (630/@rem);
    height: (813/@rem);
    transform: translateY(-((813/2)/@rem));
}

.qr-bg {
    position: absolute;
    // left: (120/@rem);
    // top: (390/@rem);
    width: (630/@rem);
    height: (733/@rem);
    background-image: url("../assets/qr_bg.png");
    background-size: contain;
    background-repeat: no-repeat;
    margin-bottom: (117/@rem);
}

.qr{
    position: absolute;
    left: (91/@rem);
    top: (283/@rem);
    width: (334/@rem);
    height: (357/@rem);
}

img {
    width: 100%;
}


img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
img:active{
  -webkit-transform: scale(1);
}


.clqr-btn {
    position: absolute;
    right: (210/@rem);
    top: (728/@rem);
    width: (80/@rem);
    height: (80/@rem);

  .animation(ScaleS2B2S 1s linear infinite);
}

.show-QrPop {
    display: block !important;
}
</style> 